module.exports = __webpack_public_path__ + "img/RegFees-OD-cancellation.bbaf5489.svg";